import type { Messages } from './fa'

const ar: Messages = {
  common: {
    loading: 'جارٍ التحميل…',
    back: 'رجوع',
    copy: 'نسخ',
    copied: 'تم النسخ',
    error: 'خطأ',
    retry: 'إعادة',
    play: 'العب',
    go: 'اذهب',
    save: 'حفظ',
    send: 'إرسال',
    cancel: 'إلغاء',
    confirm: 'تأكيد',
    friend: 'صديق',
    noName: 'بدون اسم',
    all: 'الإجمالي',
    daily: 'يومي',
    monthly: 'شهري',
    rank: 'الترتيب',
    league: 'الدوري',
    bigMatch: 'مباراة كبيرة',
    user: 'مستخدم',
    submitting: 'جارٍ التسجيل…',
    sending: 'جارٍ الإرسال…',
    watchingAd: 'جارٍ عرض الإعلان…',
    free: 'مجاني',
    search: 'بحث',
    cardMasked: 'البطاقة: **** **** **** {last4}',
  },
  coins: {
    gold: 'ذهبي',
    silver: 'فضي',
    bronze: 'برونزي',
    diamond: 'ماسي',
    coin: 'عملة',
  },
  nav: {
    aria: 'القائمة الرئيسية',
    home: 'الرئيسية',
    games: 'الألعاب',
    football: 'كرة القدم',
    horse: 'الخيل',
    airdrop: 'إيردروب',
    gift: 'هدية',
    profile: 'الملف',
  },
  home: {
    hello: 'مرحباً، {name}',
    luckyTitle: 'أرقام الحظ',
    luckySub: '٤ مراحل · برونز إلى ماس · ٢٠ دقيقة',
    quickStart: 'بداية سريعة',
    allGames: 'كل الألعاب ‹',
    tiles: {
      airdrop: { title: 'إيردروب يومي', subtitle: 'جائزة كل يوم' },
      guess: { title: 'خمّن الرقم', subtitle: '٧ أرقام · بدون ٤' },
      football: { title: 'كرة القدم', subtitle: 'دوري ومباراة كبيرة' },
      horse: { title: 'استطلاع الخيل', subtitle: 'سباق وتوقعات' },
      gift: { title: 'بطاقة هدية', subtitle: 'احصل على كود' },
      wallet: { title: 'المحفظة', subtitle: 'رصيد العملات' },
      cash: { title: 'صرف', subtitle: 'سحب الجوائز' },
      profile: { title: 'الملف', subtitle: 'المستوى والدعوات' },
      support: { title: 'الدعم', subtitle: 'دردشة مع الفريق' },
    },
    social: {
      sectionAria: 'قنواتنا',
      title: 'قنواتنا',
      instagram: 'إنستغرام',
      telegram: 'تيليجرام',
      twitter: 'تويتر',
      youtube: 'يوتيوب',
      tiktok: 'تيك توك',
    },
  },
  games: {
    title: 'الألعاب',
    subtitle: 'اختر لعبة وادخل',
    status: 'الحالة',
    chances: 'الفرص',
    of10: '{n} من ١٠',
    todayNumber: 'رقم اليوم',
    revealed: 'تم كشف الرقم',
    active: 'اللعبة نشطة',
    waiting: 'بانتظار الرقم',
    cards: {
      guess: {
        title: 'خمّن الرقم',
        subtitle: 'رقم من ٧ خانات بدون ٤',
      },
      lucky: {
        title: 'أرقام الحظ',
        subtitle: '٤ مراحل · برونز إلى ماس · ٢٠ دقيقة',
        blurb: 'اختر الأرقام. نفدت الفرص؟ شاهد إعلاناً.',
      },
      morse: {
        title: 'شيفرة مورس',
        subtitle: 'زر مورس · عملة ذهبية',
        blurb: 'ابنِ الكلمة بمورس. صحيح: ذهب؛ للمعرّف: فضة.',
      },
      horse: {
        title: 'استطلاع الخيل',
        subtitle: 'دوري · ٣ من ٤ · توأم',
        blurb: 'توقّع نتائج السباق ببرونز مقابل ذهب/ماس.',
      },
    },
  },
  wallet: {
    title: 'المحفظة',
    subtitle: 'الأرصدة والصرف',
    approxValue: 'القيمة باليورو',
    cashTitle: 'صرف العملات',
    cashHint: 'للصرف عبر المدير أو التحويل لمستخدم آخر، انتقل إلى صفحة الصرف.',
    goCashOut: 'الذهاب للصرف',
    convertTitle: 'تحويل العملات',
    convertHint: 'يحدد المدير سعر كل عملة باليورو. تحصل فقط على عدد صحيح من عملة الوجهة، والباقي يبقى في عملة المصدر.',
    convertFrom: 'من',
    convertTo: 'إلى',
    convertAmount: 'الكمية',
    convertBalance: 'الرصيد: {n}',
    convertValue: 'قيمة {amount} {coin}: {eur}',
    convertResult: 'تحصل على {receive} {to} · يبقى {leftover} {from}',
    convertTooSmall: 'يلزم {min} {from} على الأقل مقابل {to} واحدة',
    convertSame: 'يجب أن تختلف عملة المصدر عن الوجهة',
    convertSubmit: 'تحويل',
    convertOk: 'تحول {spent} {from} إلى {receive} {to}',
    convertNeedFunds: 'الرصيد غير كافٍ',
    eachRate: 'كل عملة {eur}',
  },
  cashOut: {
    title: 'صرف',
    subtitle: 'تحويل عملات أو سحب عبر المدير',
    unlock: 'فتح بالرمز',
    setPin: 'تعيين الرمز',
    enterPin: 'إدخال الرمز',
    pinHint: 'رمز من ٤ إلى ٨ أرقام',
    toAdmin: 'إلى المدير',
    toUser: 'إلى مستخدم',
    amount: 'المبلغ',
    coinType: 'نوع العملة',
    walletAddress: 'عنوان المحفظة',
    recipient: 'معرّف المستلم',
    submit: 'إرسال الطلب',
    transfer: 'تحويل',
    history: 'السجل',
    statusCompleted: 'مكتمل',
    statusPending: 'قيد الانتظار',
    statusApproved: 'موافقة المدير',
    statusRejected: 'مرفوض',
    pinSetOk: 'تم تعيين الرمز بنجاح',
    pinUnlockOk: 'تم فتح قسم الصرف',
    pinWrong: 'رمز غير صحيح',
    pinSetErr: 'تعذّر تعيين الرمز',
    transferOk: 'تم التحويل بنجاح',
    transferErr: 'فشل التحويل',
    adminOk: 'تم تسجيل طلب الصرف',
    adminErr: 'تعذّر تسجيل الطلب',
    errPinLength: 'يجب أن يكون الرمز من ٤ إلى ٦ أرقام',
    errUnlockFirst: 'ادخل قسم الصرف بالرمز أولاً',
    errAmount: 'أدخل كمية العملات',
    errInsufficient: 'الرصيد غير كافٍ',
    errRecipient: 'أدخل معرّف المستلم أو اسم المستخدم',
    errWallet: 'أدخل عنوان المحفظة',
    intro: 'اصرف هنا العملات التي حصلت عليها من الألعاب والجوائز، أو أرسلها إلى مستخدم آخر.',
    sectionTitle: 'الدخول إلى الصرف',
    pinSetupHint: 'عيّن أولاً رمزاً لهذا القسم',
    unlockedHint: 'قسم الصرف مفتوح',
    pinEnterHint: 'أدخل رمزك للدخول',
    unlockPinBtn: 'الدخول بالرمز',
    lock: 'قفل',
    lockedBanner: 'قسم الصرف مقفل. عيّن الرمز أو أدخله أولاً.',
    tabAdmin: 'تحويل إلى المدير',
    tabUser: 'تحويل إلى مستخدم',
    walletPlaceholder: 'عنوان محفظة الوجهة',
    recipientLabel: 'معرّف أو اسم المستخدم للمستلم',
    recipientPlaceholder: 'مثال: 84729103 أو @username',
    amountLabel: 'كمية العملات',
    amountPlaceholder: 'الكمية',
    submitAdmin: 'تسجيل الصرف لدى المدير',
    submitUser: 'تحويل إلى المستخدم',
    historyTitle: 'سجل الصرف',
    historyEmpty: 'لم يُسجَّل أي طلب بعد',
    historyToUser: 'إلى المستخدم {id}',
    historyToAdmin: 'إلى المدير',
    modalSetTitle: 'تعيين رمز قسم الصرف',
    modalUnlockTitle: 'الدخول إلى قسم الصرف',
    modalSetBody: 'اختر رمزاً من ٤ إلى ٦ أرقام ليكون الوصول لهذا القسم لك وحدك.',
    modalUnlockBody: 'أدخل رمز قسم الصرف',
    pinPlaceholder: 'رمز من ٤–٦ أرقام',
    modalSetSubmit: 'تعيين ودخول',
    modalUnlockSubmit: 'دخول',
  },
  profile: {
    language: 'اللغة',
    languageHint: 'اختر لغة الواجهة',
    invites: 'الدعوات',
    level: 'المستوى',
    bestCoin: 'أفضل عملة',
    idLabel: 'المعرّف',
    idCopyTitle: 'نسخ المعرّف لتحويل العملات',
    achievements: 'الإنجازات',
    badgeFirst: 'أول عملة',
    badgeInvite: '٥ دعوات ناجحة',
    badgeLucky: 'مرحلة الحظ ٣',
    luckyProgress: 'التقدّم · أرقام الحظ',
    footballScore: 'نقاط كرة القدم',
    footballScoreHint: 'النقاط التراكمية لا تُصفَّر.',
    noLeagueYet: 'لم تشارك بعد في دوري أو مباراة كبيرة',
    footballPrizes: 'جوائز كرة القدم',
    inviteFriends: 'دعوة الأصدقاء',
    inviteHint: 'شارك الرمز أو QR — عملة برونزية لكل تسجيل.',
    qrLabel: 'رمز QR لرابط الدعوة',
    qrHint: 'امسح لفتح رابط الدعوة',
    copyInviteLink: 'نسخ رابط الدعوة',
    linkCopied: 'تم نسخ الرابط',
    topUsers: 'أفضل المستخدمين',
    topUsersHint: 'الأوائل في كرة القدم والخيل والإيردروب والدعوات',
    viewTopUsers: 'عرض أفضل المستخدمين',
  },
  register: {
    subtitle: 'أدخل رمز الدعوة للبدء',
    pendingTeam: 'بعد التسجيل ستنتقل إلى فريق الأحلام المدعو',
    noCodeTitle: 'ليس لديك رمز إحالة؟',
    noCodeHint: 'إذا لم يكن لديك رمز إحالة، أدخل @sisil_org في الحقل أدناه.',
    referralLabel: 'رمز الإحالة',
    referralPlaceholder: '@sisil_org',
    getRandomCode: 'الحصول على رمز عشوائي',
    submit: 'تسجيل والدخول',
    submitting: 'جارٍ التسجيل…',
    foot: 'أدخل رمز صديقك؛ وإن لم يكن لديك فاستخدم @sisil_org.',
    needTelegram: 'يرجى الدخول عبر بوت تيليجرام',
    noTgData: 'بيانات تيليجرام غير موجودة. يرجى الدخول عبر البوت.',
    registerFail: 'فشل التسجيل. حاول مرة أخرى.',
    registerErr: 'خطأ في التسجيل.',
    codeFetchErr: 'تعذّر جلب رمز الإحالة',
  },
  support: {
    title: 'الدعم',
    meta: 'دردشة مباشرة · تُحذف الرسائل بعد ٧ أيام',
    empty: 'مرحباً! اكتب سؤالك هنا.',
    placeholder: 'اكتب رسالتك…',
    sendErr: 'فشل الإرسال',
  },
  airdrop: {
    title: 'إيردروب',
    subtitle: 'حضور يومي وجوائز',
    wallet: 'المحفظة',
    leadersToday: 'أوائل اليوم',
    leadersMonth: 'أوائل الشهر',
    usefulTime: 'الوقت المفيد',
    play: 'لعب',
    cooldown: 'استراحة',
    watchAd: 'مشاهدة إعلان',
    claim: 'استلام الجائزة',
    toastUsefulCharged: 'تم شحن ٥ دقائق مفيدة',
    scoreToday: 'نقاط اليوم',
    waitNextTurn: 'انتظر حتى الدور التالي',
    usefulTimerActive: '٥ دقائق مفيدة (فقط عندما تكون في الصفحة)',
    closedHours: 'مغلق من الساعة ٢٣:٠٠ حتى ٠٠:٠٠',
    berlinTime: 'توقيت ألمانيا',
    tapAriaActive: 'انقر للنقاط',
    tapAriaLocked: 'الإيردروب غير نشط',
    glassClosed: 'مغلق',
    glassCooldown: 'انتهى الدور',
    glassClosedDetail: '٢٣:٠٠ حتى ٠٠:٠٠ · توقيت ألمانيا',
    glassCooldownDetail: 'انتظر {time} أو شاهد إعلاناً',
    watchAdInstant: 'شاهد إعلاناً · شحن فوري لـ ٥ دقائق',
    hintRegistering: 'جارٍ التسجيل…',
    hintConnecting: 'جارٍ الاتصال…',
    hintTimerRunning: 'المؤقت يعمل · كل ضغطة +١',
    hintTimerPaused: 'المؤقت متوقف · عُد إلى الصفحة',
    hintNightlyClosed: 'هذه الساعة مغلقة للجميع كل ليلة',
    hintCooldownOrAd: 'انتظر ٥ دقائق، أو اشحن فوراً بإعلان',
    leadersTablistAria: 'الأوائل',
    emptyNoScores: 'لم تُسجَّل نقاط بعد',
    emptyNoData: 'لا توجد بيانات',
  },
  football: {
    title: 'كرة القدم',
    subtitle: 'اختر الدوري اليومي أو المباراة الكبيرة',
    modeLeague: 'الدوري اليومي',
    modeBig: 'مباراة كبيرة',
    dailyLeague: 'الدوري اليومي',
    hintLeague:
      'مباريات يومية: اختر فوز / تعادل / خسارة لكل مباراة (١–٣ اختيارات) وأرسل معاً — اختيار واحد صحيح=٨، اثنان مع إصابة=٤، الثلاثة=٢. أول اليوم ذهب (المعرّف فضة)؛ أول ٥ في الشهر ذهب.',
    hintBig:
      'مباريات أسبوعية: اختر النتيجة وابنِ فريق أحلام؛ تُسحب قرعة بين ٥ متوقعين صحيحين ويفوز أفضل فريق أحلام بعملة.',
    tabMatches: 'المباريات',
    tabLeaderboard: 'الترتيب',
    tabDreamTeams: 'فرق الأحلام',
    tabWinnings: 'جوائزي',
    totalScore: 'النقاط الكلية',
    dayScore: 'اليوم',
    monthScore: 'الشهر',
    noScore: 'لا نقاط بعد',
    noWinnings: 'لا جوائز بعد',
    goldCoin: 'عملة ذهبية',
    silverCoin: 'عملة فضية',
    submitPredictions: 'شاهد فيديو وسجّل الآراء',
    submitting: 'جارٍ عرض الفيديو / التسجيل…',
    pickRequired: 'اختر نتيجة واحدة على الأقل لكل مباراة',
    loadingMatches: 'جارٍ تحميل المباريات…',
    noBigMatch: 'لا مباراة كبيرة حالياً',
    noLeagueMatch: 'لا مباراة دوري حالياً',
    noActiveLeague: 'لا دوري نشط',
    readyBatch: 'لتسجيل {n} مباريات يجب مشاهدة فيديو',
    draftHint: 'شارك في استطلاع {n} مباريات مفتوحة ثم أرسل معاً',
    topOf: 'أوائل {mode}',
    wonPrizes: 'الجوائز الفائزة',
    dayMonth: 'يوم {day} · شهر {month}',
    outcomeHome: 'فوز',
    outcomeAway: 'خسارة',
    outcomeDraw: 'تعادل',
    dayGoalsTitle: 'تخمين مجموع أهداف اليوم',
    dayGoalsHint:
      'خمّن مجموع أهداف المضيف والضيف في {n} مباريات اليوم. إذا صح الاثنان تحصل على {silver} فضة (بدون مكافأة المُحيل). التكلفة: برونز واحد أو فيديو.',
    dayGoalsHome: 'مجموع أهداف المضيف',
    dayGoalsAway: 'مجموع أهداف الضيف',
    dayGoalsPayBronze: 'تسجيل بـ {n} برونز',
    dayGoalsPayAd: 'مشاهدة فيديو',
    dayGoalsSubmitAfterAd: 'تسجيل التخمين',
    dayGoalsAdReadyHint: 'تمت مشاهدة الفيديو — سجّل تخمينك الآن',
    dayGoalsSubmitted: 'تم التسجيل: مضيف {home} · ضيف {away}',
    dayGoalsInvalid: 'عدد الأهداف يجب أن يكون عدداً صحيحاً ≥ 0',
    dayGoalsErr: 'خطأ في تسجيل تخمين الأهداف',
    draws: {
      daily_correct: 'قرعة الدوري اليومية',
      weekly_correct: 'قرعة المباراة الكبيرة الأسبوعية',
      daily_top: 'أعلى نقاط اليوم',
      daily_referral: 'مكافأة إحالة فائز اليوم',
      monthly_top: 'أوائل الشهر',
      best_dream_team: 'أفضل فريق أحلام',
      weekly_dream_team_raffle: 'قرعة فرق الأحلام',
      league_day_goals: 'مجموع أهداف يوم الدوري',
    },
    errSubmitPrediction: 'خطأ في تسجيل التوقع',
    errSubmitPoll: 'خطأ في تسجيل الاستطلاع',
    statusLive: 'مباشر',
    statusFinished: 'انتهت',
    statusUpcoming: 'قادمة',
    yourPoll: 'استطلاعك',
    yourPrediction: 'توقعك',
    pickedSuffix: '(بالنسبة إلى {team})',
    pickHint: 'النتيجة من منظور {team} — فوز / تعادل / خسارة:',
    pollClosed: 'استطلاع هذه المباراة مغلق',
    predictionClosed: 'توقع هذه المباراة مغلق',
    buildDreamTeam: 'بناء فريق الأحلام',
  },
  horse: {
    title: 'استطلاع الخيل',
    subtitle: 'توقعات السباق والجوائز',
    modesTitle: 'الأوضاع',
    leaderboard: 'الترتيب',
    myBets: 'توقعاتي',
    mode: {
      league: {
        label: 'دوري',
        fee: 'مجاني',
        hint: '٥–١٥ سباقاً متتالياً · حصان واحد · نقاط ٩…١ · الفائز ذهب · أوائل الشهر',
      },
      three_in_four: {
        label: 'ثلاثة من أربعة',
        fee: '٢ برونز أو ٥ فيديو',
        hint: '٤ سباقات · ٤ نشطة لكل سباق · رتّب ١…٤ في كل سباق · مجموع النقاط · ذهب',
      },
      twins: {
        label: 'توأم',
        fee: '٢ برونز أو ٥ فيديو',
        hint: '٥ سباقات · حصانان · ٣ صحيحة ذهب / ٥ صحيحة ماس',
      },
      three_one: {
        label: 'ثلاثة إلى واحد',
        fee: '٢ برونز أو ٥ فيديو',
        hint: '٥ سباقات · ٣ خيول · ٥ مراكز أولى → ذهب',
      },
      more_chance: {
        label: 'فرصة أكبر',
        fee: '١ برونز أو ٣ فيديو',
        hint: '٥ سباقات · حصانان · أفضل مركز · ≥٤٣ ذهب',
      },
    },
    errLoad: 'خطأ في التحميل',
    errGeneric: 'خطأ',
    errWatchAdsFirst: 'شاهد {n} فيديو أولاً',
    msgSubmitted: 'تم تسجيل الاستطلاع',
    errNotSubmitted: 'لم يُسجَّل',
    msgAdProgress: 'تم تسجيل الفيديو · {watched} من {required}',
    errAdFailed: 'لم يُسجَّل الإعلان',
    finishPosition: 'المركز {n}',
    entryPrefix: ' · الدخول: ',
    monthlyTop: 'أفضل المستخدمين الشهري',
    yourScore: 'نقاطك:',
    todayScore: '(اليوم {n})',
    emptyNoScores: 'لا نقاط بعد',
    openPollsTitle: 'الاستطلاعات المفتوحة',
    emptyNoPolls: 'لا استطلاع سباق',
    roundEntryPaid: 'الدخول {bronze} برونز أو {ads} فيديو',
    courseCount: ' · {n} سباق',
    join: 'مشاركة',
    entrySubmitted: 'مُسجَّل · النقاط: {score}',
    entryWinner: ' · فائز {amount} {type}',
    orderHint: 'حدّد الترتيب (١ = الأمام)',
    placeAmongHint: 'حدّد ترتيب هذه الخيول الأربعة النشطة: الأول والثاني والثالث والرابع',
    placeOption: 'المركز {n}',
    pickNHorses: ' · اختيار {n} خيول',
    submitPoll: 'تسجيل الاستطلاع',
    submitWithBronze: 'تسجيل بـ {n} برونز',
    watchVideos: 'شاهد فيديو ({watched} من {required})',
    submitWithVideos: 'تسجيل بالفيديو ({n})',
    roundLeaderboard: 'ترتيب هذه الجولة',
    votingClosed: 'التسجيل مغلق — بدأ السباق أو أغلقه المشرف',
    historyTitle: 'سجل توقعاتي',
    historyEmpty: 'لم تشارك في استطلاع بعد',
    historyView: 'عرض',
    historyYourPicks: 'اختيارك',
    historyOfficial: 'النتيجة الرسمية',
    historyPending: 'النتيجة لم تُسجَّل بعد',
    historyStatusOpen: 'جارٍ',
    historyStatusWaiting: 'بانتظار النتيجة',
    historyStatusSettled: 'النتيجة سُجّلت',
    historyScore: 'النقاط {score}',
    historyCorrect: '{n} صحيح',
    historyMine: 'اختيارك',
    historyPredicted: 'التوقع: المركز {n}',
    historyNoRound: 'بيانات هذه الجولة غير متاحة',
    historyOpenPoll: 'فتح هذا الاستطلاع',
  },
  gift: {
    title: 'بطاقة هدية',
    subtitle: 'احصل على الأكواد واستخدمها',
    redeem: 'استخدام الكود',
    myCodes: 'أكوادي',
    statusUsedWithPrize: 'مستخدم · الجائزة: {prize}',
    statusUsed: 'مستخدم',
    statusExpired: 'منتهٍ',
    statusActiveHint: 'نشط — اضغط عليه للتعبئة',
    badgeUsed: 'مستخدم',
    badgeExpired: 'منتهٍ',
    badgeActive: 'نشط',
    errEnterCode: 'أدخل الكود',
    errInvalidCode: 'الكود غير صالح',
    noticeAlreadyUsed: 'هذا الكود استُخدم من قبل.',
    noticeExpired: 'هذا الكود منتهٍ ولم يعد صالحاً.',
    noticeNotFound: 'لم يُعثر على هذا الكود.',
    errPickPrize: 'اختر جائزة',
    claimOk: 'تم تسجيل الجائزة',
    errClaim: 'خطأ في تسجيل الجائزة',
    intro:
      'إذا فزت في الإيردروب، أدخل الكود الصالح لساعة هنا لترى الجوائز وتختار واحدة.',
    codeLabel: 'كود المكافأة',
    codePlaceholder: 'مثلاً AIRDWARD-...',
    enterPrizes: 'الدخول إلى الجوائز',
    activeCodesTitle: 'الأكواد النشطة ({n})',
    inactiveCodesTitle: 'الأكواد المستخدمة / المنتهية ({n})',
    activeCodeLabel: 'كود نشط',
    pickTitle: 'اختر جائزة واحدة',
    claimPrize: 'تسجيل الجائزة',
    doneTitle: 'تم تسجيل الجائزة',
    doneNote: 'هذا الكود استُخدم ولم يعد قابلاً للاستخدام.',
    exit: 'الخروج من الهدايا',
  },
  guess: {
    title: 'خمّن الرقم',
    subtitle: '٧ أرقام بدون ٤',
    errSevenDigits: 'يجب أن يكون الرقم من ٧ خانات',
    errNoFour:
      'الرقم ٤ غير مسموح — أدخل رقماً بدون ٤ (الأرقام المسموحة: ٠،١،٢،٣،٥،٦،٧،٨،٩)',
    errSubmit: 'خطأ في تسجيل التخمين',
    statusUnavailable: 'تعذّر جلب حالة اللعبة',
    revealAt: 'الكشف الساعة ٢٣:٣٠',
    todayPrompt: 'ما رقم اليوم؟',
    hint: 'خمّن رقماً من ٧ خانات بدون الرقم ٤. كل رقم يُسجَّل مرة واحدة فقط.',
    placeholder: 'مثلاً 1235678',
    attemptsLeft: 'الفرص المتبقية',
    submit: 'تسجيل التخمين',
    revealedTitle: 'تم كشف رقم اليوم',
    bannerWin: 'تهانينا! فزت اليوم',
    bannerLose: 'للأسف لم تفز اليوم',
    winnersCount: 'فاز {n} أشخاص اليوم',
    noWinners: 'لا فائزين اليوم',
    waitingNoNumber: 'لم يُحدَّد رقم اليوم بعد',
    waitingSchedule: 'يُولَّد في ٠٠:٠١ · يُكشف في ٢٣:٣٠',
    untilReveal: 'حتى الكشف: {countdown}',
    winnersToday: 'فائزو اليوم',
    userHash: 'مستخدم #{id}',
    correctTag: 'صحيح',
  },
  lucky: {
    title: 'أرقام الحظ',
    subtitle: '٤ مراحل حتى الماس',
    unlimited: 'غير محدود',
    toastDemotedStageChance: 'انتهى وقت أو فرص هذه المرحلة — عدت إلى المرحلة الأولى',
    toastPickExact: 'يجب أن تختار {n} أرقاماً بالضبط',
    toastDemotedStage: 'انتهى وقت هذه المرحلة — عدت إلى المرحلة الأولى',
    toastAdCharged: '✅ تم شحن الفرص',
    chancesLabel: 'الفرص',
    stepsAria: 'المراحل',
    windowClosed: 'نافذة اللعب اليوم مغلقة. عُد غداً.',
    allDoneTitle: 'اكتملت كل المراحل اليوم!',
    allDoneHint: 'غداً تحصل على فرص جديدة.',
    sessionExpiredStage1:
      'انتهى وقت هذه الجلسة. تبقى ٣ فرص مجانية لليوم كما هي وتُملأ غداً. الفيديو ما زال غير محدود.',
    sessionExpiredRestart: 'انتهى وقت هذه المرحلة. عند البدء من جديد تعود إلى المرحلة الأولى.',
    restart: 'البدء من جديد',
    hintPick: 'اختر {pick} من بين {pool} رقماً',
    hintOneWinner:
      'رقم واحد فقط صحيح بين {pool} رقماً — إذا كان ضمن اختياراتك تفوز',
    rewardLine: 'الجائزة: عملة {coin} · المختار {selected}/{pick}',
    stage1Quota: '٣ فرص مجانية لليوم كله وتُملأ غداً · كل فيديو +٥ فرص',
    stageFreePrefix: 'المجاني في هذه المرحلة: {free}',
    noAds: ' · بدون إعلان',
    adsRemaining: ' · الإعلانات المتبقية: {n}',
    stageTimeLimit: ' · ٢٠ دقيقة',
    confirmPicks: 'تأكيد الاختيارات',
    needAdNoFree: 'هذه المرحلة بلا فرص مجانية. شاهد إعلاناً لتخمّن.',
    needAdRecharge: 'نفدت الفرص. اشحنها بمشاهدة إعلان.',
    watchAdPlus: 'شاهد إعلاناً · +{n} فرصة',
    loseDemotedTitle: 'عدت إلى المرحلة الأولى',
    loseTitle: 'خسرت!',
    correctWas: 'الرقم الصحيح كان',
    loseDemotedHint: 'عدت إلى المرحلة الأولى. الفرص المجانية لليوم هي ما تبقّى.',
    loseNumbersChanged: 'للمحاولة التالية تغيّرت أرقام الحظ.',
    attemptsLeft: 'الفرص المتبقية: {n}',
    continueStage1: 'المتابعة في المرحلة الأولى',
    tryAgain: 'حاول مرة أخرى',
  },
  morse: {
    title: 'شيفرة مورس',
    subtitle: 'ابنِ الكلمة بمورس',
    errEnterWord: 'أدخل الكلمة بزر مورس',
    windowClosedTitle: 'نافذة اللعب اليوم مغلقة',
    windowClosedHint: 'تُفتح غداً من منتصف الليل حتى ٢٣:٣٠ بتوقيت ألمانيا',
    solved: 'محلول',
    timeLeft: 'الوقت المتبقي',
    clock: 'الساعة',
    keyTitle: 'مفتاح مورس',
    keyHint: 'قصير = نقطة · الاستمرار = خط. بعد التوقف يُسجَّل الحرف.',
    readoutWord: 'Word',
    keyLabel: 'Morse',
    keyHoldHint: 'hold · · —',
    backspace: '⌫ حذف',
    submitGuess: 'تسجيل التخمين',
    clearAll: 'مسح الكل',
    sessionEnded: 'انتهت جلسة هذا الدور',
  },
  topUsers: {
    title: 'أفضل المستخدمين',
    subtitle: 'الأوائل في الأقسام المختلفة',
    emptyFootball: 'لم تُسجَّل نقاط في دوري كرة القدم بعد',
    emptyHorse: 'لا نقاط في دوري الخيل بعد',
    emptyAirdrop: 'لم تُسجَّل نقاط في الإيردروب بعد',
    emptyInvite: 'لم تُسجَّل أي دعوة بعد',
    scoreLabel: 'النقاط',
    inviteLabel: 'الدعوة',
  },
  dreamTeam: {
    title: 'فريق الأحلام',
    titlePlural: 'فرق الأحلام',
    brandBoard: 'فريق الأحلام · Sisil',
    defaultTeamName: 'فريق أحلامي',
    matchVs: '{home} ضد {away}',
    listSeparator: '، ',
    positions: {
      gk: 'حارس المرمى',
      def: 'مدافع',
      mid: 'وسط',
      fwd: 'مهاجم',
      voteShort: {
        def: 'دفاع',
        fwd: 'هجوم',
      },
    },
    status: {
      draft: 'مسودة',
      submitted: 'مُرسَل',
      submittedSpaced: 'تم الإرسال',
      notSubmitted: 'غير مُرسَل',
      teamSubmittedCheck: 'تم إرسال الفريق ✓',
      teamSubmittedHeading: '✅ تم إرسال فريق الأحلام',
    },
    explore: {
      ariaSearch: 'بحث',
      searchPlaceholder: 'بحث…',
      empty: 'فارغ',
      notFound: 'غير موجود',
      exploreTeams: '🔍 استكشاف الفرق',
    },
    view: {
      notFound: 'لم يُعثر على فريق الأحلام هذا',
      backToExplore: 'العودة إلى الاستكشاف',
      labelTeamName: 'اسم فريق الأحلام',
      labelFormation: 'تشكيل الفريق',
      metaRating: '★ {avg} ({votes}) · {totalScore} نقطة',
      creator: 'المنشئ: {name}',
      buildMyTeam: 'بناء فريقي',
      pitchAlt: 'رسوم متحركة لملعب فريق الأحلام',
    },
    builderPage: {
      matchNotFound: 'المباراة غير موجودة',
      backToFootball: 'العودة إلى كرة القدم',
    },
    builder: {
      toastEnterName: 'أدخل اسم فريق الأحلام',
      toastPlayersRemaining: 'تبقّى {remaining} لاعبين ({selected} من {total})',
      toastSaveError: 'خطأ في حفظ فريق الأحلام',
      toastUpdated: 'تم تحديث فريق الأحلام',
      toastCreated: 'تم إنشاء فريق الأحلام',
      toastSubmitted: 'تم إرسال فريق الأحلام',
      toastSubmitError: 'خطأ في إرسال فريق الأحلام',
      toastAnimationFailed: 'تعذّر إنشاء الصورة المتحركة',
      toastLinkCopied: 'تم نسخ رابط الفريق',
      toastFileNotReady: 'الملف غير جاهز بعد',
      toastWaitForFile: 'انتظر حتى يجهز الملف…',
      toastVideoSaved: 'تم حفظ الفيديو — ضع الفيديو نفسه في الستوري ليظهر التحريك',
      toastGifSaved: 'تم حفظ الجيف — إذا بقيت الستوري ثابتة فاستخدم الفيديو',
      toastStoryStepsVideo:
        'الفيديو في المعرض → ستوري جديدة → اختر الفيديو نفسه → الصق الرابط',
      toastStoryStepsFile:
        'الملف في المعرض → ستوري جديدة → اختر الملف نفسه → الصق الرابط',
      labelTeamName: 'اسم فريق الأحلام',
      labelFormation: 'تشكيل الفريق',
      placeholderTeamName: 'مثال: فريق أحلامي',
      activeCardGroups: 'مجموعات البطاقات النشطة لهذه المباراة:',
      noActiveCards:
        'لا توجد بطاقة نشطة لهذه المباراة. يجب أن يختار المشرف مجموعات بطاقات هذه المباراة في تبويب «كرة القدم».',
      pickEmpty: 'اختيار',
      playersSelected: 'اللاعبون المختارون: {selected} من {total}',
      filterAll: 'الكل ({count})',
      pickPositionTitle: '{icon} اختيار {position}',
      pickSlotHint: 'اختر خانة على الملعب',
      cardCount: '{count} بطاقة',
      tapEmptySlot: 'اضغط على إحدى الخانات الفارغة في الملعب',
      noCardsForPosition: 'لا بطاقة لهذا المركز في المجموعات النشطة لهذه المباراة',
      searchPlayerPlaceholder: 'البحث عن اسم اللاعب...',
      badgeSelected: 'مختار',
      badgeInTeam: 'في الفريق',
      badgeAdd: '+ إضافة',
      submittedBlurb:
        'بعد الإرسال يُقفَل التشكيل ويدخل في القرعة ومنافسة «أفضل فريق أحلام».',
      copyLink: 'نسخ الرابط',
      shareTeam: '📤 مشاركة الفريق',
      submitTeam: 'إرسال الفريق',
      saving: 'جارٍ الحفظ...',
      updateTeam: 'تحديث الفريق',
      buildTeam: 'بناء الفريق ({selected}/{total})',
      shareModal: {
        title: 'ستوري مع تحريك الملعب',
        buildingComposition: 'جارٍ إنشاء تحريك التشكيل…',
        fileNotReady: 'الملف غير جاهز بعد',
        instagramTip:
          'إنستغرام يثبّت جيف المعرض عادة — ضع فيديو قصيراً لتتحرك البطاقات.',
        instagramSteps:
          '١) احفظ/شارك هذا الملف ٢) ستوري → الفيديو/الجيف نفسه ٣) الصق الرابط بملصق.',
        building: 'جارٍ إنشاء التحريك…',
        shareVideo: '📤 حفظ / مشاركة فيديو الملعب',
        shareGif: '📤 حفظ / مشاركة جيف الملعب',
        downloadVideo: 'تنزيل الفيديو',
        downloadGif: 'تنزيل الجيف',
        copyBotLink: 'نسخ رابط البوت',
      },
    },
    image: {
      stickerHint: 'الصق الرابط في الستوري بملصق الرابط',
      cta: 'ابنِ فريق أحلامك واحصل على نقاط',
      unknownInitial: '؟',
    },
    voting: {
      sectionTitle: 'التقييم (١ إلى ٥)',
      alreadyVoted: 'لقد صوّتّ من قبل',
      yourRating: 'تقييمك: {rating}/5',
      pollClosed: 'استطلاع هذه المباراة مغلق',
      pollClosedHint: 'التصويت متاح فقط قبل بدء المباراة',
      ownerHint: 'هذا فريقك؛ يمكن للآخرين التصويت له.',
      slotLine: '{position} · الخانة {slot}',
      toastPollClosed: 'استطلاع هذه المباراة مغلق',
      toastVoteRecorded: 'تم تسجيل رأيك',
      toastVoteError: 'خطأ في تسجيل الرأي',
      toastCannotVoteOwn: 'لا يمكنك التصويت لفريقك',
      votingOpen: 'التصويت مفتوح',
      votingClosed: 'مغلق',
      yourTeamChip: 'فريقك',
      topTeamsTitle: 'أفضل فرق هذه المباراة',
    },
  },
  fantasy: {
    explore: {
      subtitleRefreshing: 'جارٍ التحديث…',
      subtitleDefault: 'بحث وتصويت',
      searchPlaceholder: 'ابحث عن اسم الفريق أو الرابط',
      resultsFor: 'نتيجة «{query}»',
      loadError: 'خطأ في تحميل الفرق',
      emptySearch: 'لم يُعثر على فريق بهذا الاسم أو الرابط',
      emptyDefault: 'لا يوجد فريق نشط للتصويت بعد',
      backToMatches: 'العودة إلى المباريات',
    },
    builder: {
      title: 'منشئ فريق الأحلام',
      stepOf: 'المرحلة {step} من ٢',
      stepTeamName: '📝 اسم الفريق',
      stepFormation: '🧩 تشكيل الفريق',
      stepCardGroups: '📁 مجموعات بطاقات هذه المباراة',
      cardGroupsHint: 'في المرحلة التالية يمكن اختيار بطاقات هذه المجموعات فقط.',
      nextStep: 'المرحلة التالية: ترتيب اللاعبين ←',
      registeredLineup: '📋 التشكيل المسجّل',
      toastEnterName: 'أدخل اسم الفريق',
      toastPickAllSlots: 'اختر لاعباً لكل خانة من {totalSlots}',
      toastLineupUpdated: 'تم تحديث التشكيل',
      toastTeamCreated: 'تم إنشاء الفريق بنجاح',
      toastSaveError: 'خطأ في حفظ الفريق',
      toastSubmittedForPoll: 'تم إرسال الفريق للاستطلاع',
      toastSubmitError: 'خطأ في إرسال الفريق',
      toastLinkCopied: 'تم نسخ رابط الفريق',
      toastCopyFailed: 'تعذّر نسخ الرابط',
      shareVoteText: 'صوّت لفريق أحلامي: {teamName}',
      charCount: '{length}/٤٠',
      pickSlotHint: 'اختر خانة على الملعب',
      noCardsForPosition: 'لا بطاقة لهذا المركز في مجموعات هذه المباراة',
      shareAndPoll: 'مشاركة الفريق واستطلاعه',
      copyTeamLink: 'نسخ رابط الفريق',
      seeOtherTeams: 'رؤية الفرق الأخرى',
      submitForPoll: 'إرسال للاستطلاع',
      saveTeam: 'حفظ الفريق ({selected}/{total})',
      saveHint: 'اختر كل اللاعبين ({totalSlots}) لتفعيل زر الحفظ',
    },
    vote: {
      notFound: 'الفريق غير موجود أو الرابط غير صالح',
      back: 'رجوع',
    },
  },
}

export default ar
